import { render, staticRenderFns } from "./VerifyACHCardModal.vue?vue&type=template&id=b15cf922"
import script from "./VerifyACHCardModal.vue?vue&type=script&lang=ts"
export * from "./VerifyACHCardModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports